<div class="alert alert-danger">
    <h3 class="alert-heading disconnect-msg">{{{o.disconnect_messages[0]}}}</h3>

    {[ o._.forEach(o.disconnect_messages.slice(1), function (msg) { ]}
        <p class="disconnect-msg">{{{msg}}}</p>
    {[ }); ]}
</div>
